import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { EquipmentFunction } from './equipment-function';

export class EquipmentFunctionInitialisation implements ViewModel {
  friendlyTypeNameSingular: string = 'Equipment Function Model Initialisation';
  apiRoute: string = CONFIG.apiRoutes.maintenanceAnalysisModelFunctions;

  modelId: string;
  functions: EquipmentFunction[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.modelId = data.modelId;
    this.functions.length = 0;
    if (data.functions) {
      data.functions.map((func: any) => {
        const item = new EquipmentFunction();
        item.loadFromJson(func);
        this.functions.push(item);
      });
    }
  }
}
